import React from 'react'

export interface OracleModalProps {
  isOpen: boolean
  onDismiss?: () => void
  dismissOnTapOut?: boolean
  children: React.ReactNode
  className?: string
}

export const OracleModalExports = { OracleModal: true }

export const OracleModal: React.FC<OracleModalProps> = ({
  isOpen,
  onDismiss,
  dismissOnTapOut = false,
  children,
  className,
}) => {
  if (!isOpen) return null

  const handleScrimClick = () => {
    if (dismissOnTapOut && onDismiss) onDismiss()
  }

  return (
    <>
      <div
        className="oracle-modal__scrim"
        data-testid="oracle-modal__scrim"
        onClick={handleScrimClick}
        role="presentation"
      />
      <div
        className={`oracle-modal__card${className ? ` ${className}` : ''}`}
        data-testid="oracle-modal__card"
      >
        {children}
      </div>
    </>
  )
}
